jQuery(document).ready(function($) {

let $fileUploadInput = jQuery( 'input[type="file"]' );


$fileUploadInput.each( function() {

    let $input  =   jQuery(this);
    let id      =   $input.attr( 'id' );

    $input.addClass( 'd-none' );

    let psudeoButton = {
        id : `${id}--button`,
        emptyText : 'Choose File',
        validText : 'File Chosen',
        setText : function( text ) {
            jQuery( '#'+this.id ).text( text );
        },
        init : function() {

            this.element    =   `<span class="input__button--file"><button type="button" id="${this.id}">${this.emptyText}</button></span>`;

            return this;
        }
    }.init();

    let psudeoText = {
        id : `${id}--filename`,
        emptyText : 'No File Chosen',
        setText : function( text ) {
            jQuery( '#'+this.id ).text( text );
        },
        init : function() {
            this.element = `<span id="${this.id}" class="d-inline-block input__text--file">${this.emptyText}</span>`;
            
            return this;
        }
    }.init();


    $input.after( psudeoText.element + psudeoButton.element );



    jQuery( document ).on( 'click', '#'+psudeoButton.id, () => {
        $input.click(); 
    } );



    $input.on( 'change', function() {
        let fileList = jQuery(this)[0].files;
        var filename;
        var buttonText;

        if( fileList.length > 0 ) {

            let files   =   [];
            for( var i = 0; i < fileList.length; i++  ) {

                files.push( fileList[i].name );                
            }

            filename = files.join( ', ' );
            buttonText = psudeoButton.validText;
        } else {
            filename = psudeoText.emptyText;
            buttonText = psudeoButton.emptyText;
        }

        psudeoButton.setText( buttonText );
        psudeoText.setText( filename );
    } );
} );

});